import React, { useEffect } from 'react'
import {
  getFromLocalStorage,
  loadJSONFromLocalStorage,
  saveJSONInLocalStorage
} from '../../../utils/browserStorageService'
import FPS from './FPS'
import {
  ActiveBboxDebugger,
  MapBboxDebugger,
  PolylineDebugger,
  SearchBboxDebugger,
  StepsDebugger,
  ViewportDebugger
} from './BboxDebugger'
import ZoomDebugger from './ZoomDebugger'
import { useEffectWithMapContext, useMapContext } from '../MapContext'

const mapDebuggerAPI = {
  map: null,
  ui: {
    zoom: true,
    viewport: false,
    bbox: false,
    steps: false,
    polyline: false,
    activebbox: false,
    searchbbox: false,
    fps: true
  }
}

const PREFERENCES_KEY = 'map_debug_parameters'

const MapDebuggerComponent = () => {
  const { interact } = useMapContext()

  useEffect(() => {
    window.mapDebugger = mapDebuggerAPI
    mapDebuggerAPI.setUIItem = (prop, show) => {
      mapDebuggerAPI.ui[prop] = show
      saveJSONInLocalStorage(PREFERENCES_KEY, { ui: mapDebuggerAPI.ui })
    }
    mapDebuggerAPI.show = prop => mapDebuggerAPI.setUIItem(prop, true)
    mapDebuggerAPI.hide = prop => mapDebuggerAPI.setUIItem(prop, false)
    const preferences = loadJSONFromLocalStorage(PREFERENCES_KEY)
    if (preferences && preferences.ui) mapDebuggerAPI.ui = preferences.ui
    return () => {
      delete window.mapDebugger
    }
  }, [])

  useEffectWithMapContext(map => {
    mapDebuggerAPI.map = map
  }, [])

  useEffect(() => {
    mapDebuggerAPI.interact = interact
  }, [interact])

  const { ui } = mapDebuggerAPI

  return (
    <>
      {ui.zoom && <ZoomDebugger />}
      {ui.viewport && <ViewportDebugger />}
      {ui.bbox && <MapBboxDebugger />}
      {ui.activebbox && <ActiveBboxDebugger />}
      {ui.searchbbox && <SearchBboxDebugger />}
      {ui.steps && <StepsDebugger />}
      {ui.polyline && <PolylineDebugger />}
      {ui.fps && <FPS />}
    </>
  )
}

export default function MapDebugger() {
  return getFromLocalStorage('debugMap') ? <MapDebuggerComponent /> : null
}
